export const VAT_ID_PATTERN = /^[A-Z]{2}[A-Z0-9]{2,12}$/;

export function normalizeVatId(value?: string | null): string | undefined {
  if (!value) return undefined;
  const normalized = value.replace(/[\s.-]/g, '').toUpperCase();
  return normalized.length ? normalized : undefined;
}
